module.exports = __webpack_public_path__ + "img/navpci.68fbf0ee.png";